<template>
  <div class="page with-navbar">
    <div class="only-desktop">
      <top-bar></top-bar>
    </div>
    <rebuild-nav-bar></rebuild-nav-bar>

    <div class="reg-container">
      <h2 class="reg-title">
        <router-link to="/login" class="item" @click.native="trackingAction('Login_Top')">登录</router-link>
        <router-link to="/reg" class="item active" @click.native="trackingAction('Register_Top')">注册</router-link>
      </h2>
      <div class="default-form">
        <div :class="errors.has('username') ? 'form-group error' : 'form-group'">
          <label class="form-inner">
            <div class="form-input">
              <input
                type="text"
                name="username"
                class="form-control"
                placeholder="请输入您的姓名"
                v-model="username"
                v-validate="'required'"
              />
              <div
                class="form-error"
                v-show="errors.has('username')"
              >
                {{ errors.first('username') }}
              </div>
            </div>
          </label>
        </div>

        <div :class="errors.has('phone') ? 'form-group error' : 'form-group'">
          <label class="form-inner">
            <div class="form-input">
              <input
                type="tel"
                name="phone"
                class="form-control"
                placeholder="请输入手机号码"
                v-model="phone"
                v-validate="'required|phone'"
              />
              <div
                class="form-error"
                v-show="errors.has('phone')"
              >
                {{ errors.first('phone') }}
              </div>
            </div>
          </label>
        </div>

        <div class="form-group text-right">
          <button
            type="button"
            class="button code-btn"
            @click="getSmsCode"
          >
            {{smsBtn.content}}
          </button>
        </div>

        <div :class="errors.has('smscode') ? 'form-group mt40 error' : 'form-group mt40'">
          <label class="form-inner">
            <div class="form-input">
              <input
                type="text"
                name="smscode"
                class="form-control"
                placeholder="请输入您的验证码"
                maxlength="6"
                v-model="smscode"
                v-validate="'required|alpha_num'"
              />
              <div
                class="form-error"
                v-show="errors.has('smscode')"
              >
                {{ errors.first('smscode') }}
              </div>
            </div>
          </label>
          <div class="form-tips">注册后，可随时用手机号验证登陆</div>
        </div>

        <!-- <wechat-binding></wechat-binding> -->

        <div class="checkbox-label">
          <div
            :class="isProtocolAccepted ? 'checkbox active' : 'checkbox'"
            @click="protocolToggle"
          ></div>
          <div class="text">我已阅读并同意<router-link to="/regulation" class="link" @click.native="trackingAction('Register_Terms')">使用条款</router-link>和<router-link to="/protocol" class="link" @click.native="trackingAction('Register_PrivacyPolicy')">隐私条款</router-link></div>
        </div>
        <div class="checkbox-label">
          <div
            :class="isAdult ? 'checkbox active' : 'checkbox'"
            @click="adultToggle"
          ></div>
          <div class="text">我已满18岁</div>
        </div>

        <div class="submit-area text-center">
          <button
            type="button"
            class="pink-circle-btn"
            @click="regSubmit"
          >
            <div class="wrapper">
              <span class="text">注册</span>
            </div>
          </button>
          <div class="mt20"><router-link to="/login" class="link">登录</router-link></div>
        </div>
      </div>
    </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import TopBar from '@components/TopBar'
import RebuildNavBar from '@components/RebuildNavBar'
import PageFooter from '@components/PageFooter'
import WechatBinding from '@components/WechatBinding'
import VideoBg from '@components/VideoBg'
import { mapMutations } from 'vuex'
import { verify } from '@/utils'

export default {
  name: 'Reg',
  components: {
    TopBar,
    RebuildNavBar,
    PageFooter,
    WechatBinding,
    VideoBg
  },
  data () {
    return {
      isMobile: '',
      isProtocolAccepted: false,
      isAdult: false,
      smsBtn: {
        content: '发送验证码',
        countDown: 60,
        canClick: true
      },
      username: '',
      phone: '',
      smscode: ''
    }
  },
  methods: {
    ...mapMutations(['setAuthorization', 'setNickname', 'setMobile', 'setOpenid']),
    protocolToggle () {
      this.isProtocolAccepted = !this.isProtocolAccepted
    },
    adultToggle () {
      this.isAdult = !this.isAdult
    },
    getSmsCode () {
      if (!this.smsBtn.canClick) {
        return false
      }
      this.$validator.validate('phone').then((msg) => {
        if (msg) {
          this.smsBtn.canClick = false
          this.$request.post(
            this.$apiConfig.smsUrl, {
              'telephone': this.phone,
              'type': 1
            }
          ).then(this.handleGetSmsCodeSucc)
        }
      })
    },
    handleGetSmsCodeSucc (res) {
      let resData = res.data
      // console.log(resData)

      if (resData.code == 200007) {
        alert('验证码已发送，请注意查收')
        return false
      }

      if (resData.code == 200008) {
        let loginConfirm = confirm('该手机号已注册，请去登录')
        if (loginConfirm == true) {
          this.$router.push('/login')
        }
        return false
      }

      this.smsBtn.content = this.smsBtn.countDown + 's后重新发送'
      let clock = window.setInterval(() => {
        this.smsBtn.countDown--
        this.smsBtn.content = this.smsBtn.countDown + 's后重新发送'
        if (this.smsBtn.countDown < 0) {
          window.clearInterval(clock)
          this.smsBtn.content = '重新发送验证码'
          this.smsBtn.countDown = 60
          this.smsBtn.canClick = true
        }
      }, 1000)
    },
    doReg () {
      this.$request.post(
        this.$apiConfig.regUrl, {
          'nickname': this.username,
          'telephone': this.phone,
          'code': this.smscode
        }
      ).then(this.handleDoRegSucc)
    },
    handleDoRegSucc (res) {
      let resData = res.data
      console.log(resData.code + ':' + resData.msg)
      if (resData.code == 300001) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300002) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300003) {
        alert('请输入正确的手机号')
        return false
      }

      if (resData.code == 300004) {
        alert('请输入验证码')
        return false
      }

      if (resData.code == 300005) {
        alert('验证码无效，请重新输入')
        return false
      }

      if (resData.code == 300013) {
        alert('请输入昵称')
        return false
      }

      if (resData.code == 300014) {
        alert('你输入的昵称过长')
        return false
      }

      if (resData.code == 300016) {
        alert('该用户已注册，请登录')
        return false
      }

      _jcq.push(['_track', 'Register_Bottom', {
        cellphone: this.phone,
        Name: this.username
      }])

      this.setAuthorization(resData.data.authorization)
      this.setNickname(resData.data.nickname)
      this.setMobile(resData.data.mobile)
      this.setOpenid(resData.data.openid)
      this.$router.push('/reinvent')
    },
    regSubmit () {
      if (!this.isProtocolAccepted) {
        alert('请阅读并同意使用条款和隐私条款')
        return false
      }

      if (!this.isAdult) {
        alert('未满18岁，请退出！')
        return false
      }

      this.$validator.validateAll().then((msg) => {
        console.log(msg)
        if (msg) {
          console.log('验证通过')
          this.doReg()
        }
      })
    },
    trackingAction (action) {
      _jcq.push(['_track', action])
    }
  },
  mounted () {
    if (verify.isMobile()) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  @include respond-to(desktop) {
    background-color: nth($pink, 1);
    background-repeat: no-repeat;
    background-image: url('~@static/rebuild/login_bg.jpg');
    background-size: auto 100%;
  }
}
.reg-container {
  padding: 60px 30px 30px;
  @include respond-to(desktop) {
    position: absolute;
    @include center();
    width: 300px;
    padding: 0;
  }
  .reg-title {
    margin-bottom: 40px;
    .item {
      margin-right: 40px;
      font-size: $font-lg;
      color: #c4c4c4;
      &.active {
        color: #fff;
        font-weight: 900;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .submit-area {
    margin-top: 70px;
  }
}
.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reg.vue